import { http } from 'lib/http'
import { useEffect, useRef, useState } from 'react'

type TCallRecordingState = {
 loading: boolean
 src?: string
 error?: string
}

// Recordings must go through our authenticated axios instance (never a raw
// <audio src="..."> to the API) since the CRM never exposes Twilio's URL/creds
// or a bearer token in a plain URL - fetch as a blob and play that instead.
const useCallRecording = () => {
 const [state, setState] = useState<TCallRecordingState>({ loading: false })
 const objectUrlRef = useRef<string>()

 const revoke = () => {
  if (objectUrlRef.current) {
   URL.revokeObjectURL(objectUrlRef.current)
   objectUrlRef.current = undefined
  }
 }

 const load = async (url: string) => {
  setState({ loading: true })
  try {
   const { data } = await http.get(url, { responseType: 'blob' })
   revoke()
   const objectUrl = URL.createObjectURL(data)
   objectUrlRef.current = objectUrl
   setState({ loading: false, src: objectUrl })
  } catch (error) {
   setState({ loading: false, error: 'Could not load recording' })
  }
 }

 useEffect(() => () => revoke(), [])

 return { ...state, load }
}

export default useCallRecording
